import {SECTIONS} from './constants';

import AccordionPage from '@/components/accordion-page';
import {PageContentWrapper} from '@/shared/components';

import './index.css';

const Help = () => (
  <PageContentWrapper
    className="Product__main Help"
    loading={false}
    hasResults
    emptyStateTitle="No helps found!"
  >
    <AccordionPage sections={SECTIONS} />
  </PageContentWrapper>
);

export default Help;
